import ApiBack from "../../../../utils/domains/ApiBack";
import IPS from "../../../../models/Ips";
import IPSView from "../../../../models/ipsView";
import Municipio from "../../../../models/municipio";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ServicePrivate from "../../../../services/ServicePrivate";
import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import { MessageToastify } from "../../../../utils/funtions/MessageToastify";
import { useForm } from "../../../../utils/hooks/useForm";
import { useRef } from "react";
import Deparment from "../../../../models/Deparment";
import User from "../../../../models/user";
import { jwtDecode } from "jwt-decode";
import Creditor from "../../../../models/Creditor";

export const ViewCreditor = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [process, setProcess] = useState<boolean>(false);
    const [dateContract, setDateContract] = useState("");
    const [dateUpdate2025, setDateUpdate2025] = useState("");
    const [arrayCreditor, setArrayCreditor] = useState<Creditor[]>([]);
    const [show, setShow] = useState(false);
    const [showData, setShowData] = useState(false);
    const [show2, setShow2] = useState(false);
    const [showUpdate, setShowUpdate] = useState(false);
    const [showUpActivation, setShowUpActivation] = useState(false);
    type formaHtml = React.FormEvent<HTMLFormElement>;
    const handleClose = () => setShow(false);
    const handleCloseData = () => setShowData(false);
    const handleClose2 = () => setShow2(false);
    const formRef = useRef<HTMLFormElement>(null);
    const [arrayMunicipio, setArrayMunicipio] = useState<Municipio[]>([]);
    const [haveActualization, setHaveActialization] = useState(false);
    const [dataA, setDataA] = useState("");
    const [connectiono, setConnection] = useState("");
    const [passwordServer, setPasswordServer] = useState("");
    const [nameServer, setNameServer] = useState("");
    const [passwordConnection, setPasswordConnection] = useState("");
    //function to error the Token on the time, using when token is invalid or expired
    const [search, setSearch] = useState("");
    const [arrayUsers, setArrayUsers] = useState<User>();
    const [resumen, setResumen] = useState<any>({});
    const [objIps, setObjIps] = useState<IPS>();
    const [arrayIPSUpdate, setArrayIPSUpdate] = useState<IPS[]>([]);



    let { name_creditor, type_creditor, id_municipality, document_creditor, address_creditor, phone_creditor, email_creditor, doubleLink, object } =
        useForm<Creditor>(
            new Creditor(
                0,
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                ""
            ) // Incluye `id_municipio` con un valor inicial
        );

    const [objips, setObjips] = useState<IPSView>(
        new IPSView(
            0,
            "",
            "",
            false,
            new Municipio(0, "", "", new Deparment(0, "")),
            new Date(),
            false,
            "",
            new Date(), true, true, "", "", new Date()
        )
    );

    // const cleanBox = (form: HTMLFormElement) => {
    //     form.reset();

    //     object.connection = "";
    //     object.password_connection = "";
    //     object.password_server = "";
    //     object.name_server = "";

    //     (form.querySelector('[name="name_solicited"]') as HTMLInputElement).value =
    //         "";
    //     (form.querySelector('[name="role2"]') as HTMLInputElement).value = "";
    //     (form.querySelector('[name="number"]') as HTMLInputElement).value = "";
    //     (form.querySelector('[name="requirement"]') as HTMLInputElement).value = "";

    //     form.classList.remove("was-validated");
    // };


    // Filtrar los datos según búsqueda
    const filteredIps = arrayCreditor.filter((creditor) => {
        if (!search) return true; // si no hay búsqueda, no filtramos nada
        const term = search.toLowerCase().trim();
        return (
            creditor.name_municipality.toLowerCase().includes(term)
        );
    });
    const [sortedIps, setSortedIps] = useState(filteredIps);
    const handleTokenError = () => {
        navigate("/");
    };

    const getOneIps = async (id: number) => {
        try {
            const urlGetUser = ApiBack.IPS_LIST_ONE + "/" + id;
            const result = await ServicePrivate.requestGET(urlGetUser);
            setObjips(result);
            setShow(true);
        } catch (error) {
            console.error("Error fetching profesional:", error);
            setShow(false);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError();
            }
        }
    };

    const getMunicipality = async () => {
        try {
            const urlGetMunc = ApiBack.MUNICIPIOS_LIST;
            const result = await ServicePrivate.requestGET(urlGetMunc);
            setArrayMunicipio(result);
        } catch (error) {
            console.error("Error fetching profesional:", error);
            setShow(false);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError();
            }
        }
    };
    const getIPSUpdate = async () => {
        try {
            const urlGetMunc = ApiBack.IPS_UPDATE_STATUS;
            const result = await ServicePrivate.requestGET(urlGetMunc);

            if (result) {
                setArrayIPSUpdate(result);
            }
            if (result.error) {
                MessageToastify("error", result.error, 3000)
            }
        } catch (error) {
            console.error("Error fetching profesional:", error);
            setShow(false);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError();
            }
        }
    };

    const handleShowCreate = async () => {
        setShow2(true);
        getMunicipality();

    }

    const getOneIpsUp = async (id: number) => {
        try {
            const urlGetUser = ApiBack.IPS_LIST_ONE + "/" + id;
            const result = await ServicePrivate.requestGET(urlGetUser);
            setObjips(result);
            setShowUpdate(true);
            setDateContract(result.date_contract)
            setDateUpdate2025(result.date_update2025)
            setHaveActialization(result.have_actualization)
            setConnection(result.connection)
            setPasswordConnection(result.password_connection)
            setNameServer(result.name_server)
            setPasswordServer(result.password_server)
            console.log(result);

        } catch (error) {
            console.error("Error fetching profesional:", error);
            setShow(false);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError(); // Manejar el error de token
            }
        }
    };

    const getOneIpsUpDateA = async (id: number) => {
        try {
            const urlGetUser = ApiBack.IPS_LIST_ONE_ACTIVATE + "/" + id;
            const result = await ServicePrivate.requestGET(urlGetUser);
            setObjips(result);
            setShowUpActivation(true);
            setDataA(result.data_a)
        } catch (error) {
            console.error("Error fetching profesional:", error);
            setShow(false);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError(); // Manejar el error de token
            }
        }
    };

    const getOneDataIps = async (id: number) => {
        try {
            const urlGetUser = ApiBack.IPS_LIST_ONE_DATA + "/" + id;
            const result = await ServicePrivate.requestGET(urlGetUser);
            setObjIps(result);
            setShowData(true);
        } catch (error) {
            console.error("Error fetching profesional:", error);
            setShow(false);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError(); // Manejar el error de token
            }
        }
    };

    const getAllCreditor = async () => {
        try {
            const results = await ServicePrivate.requestGET(ApiBack.VIEW_CREDITOR_ALL);
            console.log(results);
            
            if (results) {
                const payload = results.results || [];
                const resumen = results.resumen || {};
                setArrayCreditor(payload);
                setResumen(resumen)
                console.log("Este es el metodo que esta llegando");

            } else {
                setLoading(true);
            }
        } catch (error) {
            console.error("Error fetching IPS:", error);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError();
            }
        }
    };


    const getProfessionals = async () => {
        try {
            const token: any = localStorage.getItem("access");
            if (!token) {
                handleTokenError();
                return;
            }
            const decoded: any = jwtDecode(token);

            if (decoded && decoded.role) {
                setArrayUsers(decoded);
                setLoading(false);
                return;
            } else {
                console.error("El token no contiene información de usuario válida.");
                handleTokenError();
            }

        } catch (error) {
            console.error("Error fetching professionals:", error);
            setLoading(false);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError();
            }
        }
    };


    const sendForm = async (fh: formaHtml) => {
        try {
            fh.preventDefault();
            setProcess(true);
            const form = fh.currentTarget;

            form.classList.add("was-validated");

            if (form.checkValidity() === false) {
                fh.preventDefault();
                fh.stopPropagation();
                setProcess(false);
                MessageToastify(
                    "error",
                    "Por favor, completa todos los campos requeridos.",
                    7000
                );
                return;
            }

            const formData = {
                name_creditor: name_creditor,
                type_creditor: type_creditor,
                id_municipality: id_municipality,
                document_creditor: document_creditor,
                address_creditor: address_creditor,
                phone_creditor: phone_creditor,
                email_creditor: email_creditor, 
            };

            const response = await ServicePrivate.requestPOST(
                ApiBack.CREATE_CREDITOR,
                formData
            );

            if (response.OK) {
                setProcess(false);
                MessageToastify(
                    "error",
                    "error al momento de crear el nuevo cliente.",
                    5000
                );
            } else {
                setProcess(false);
                handleClose2();
                getAllCreditor();
                MessageToastify("success", "EL nuevo cliente ha sido creado.", 5000);
            }
        } catch (error) {
            setProcess(false);

            MessageToastify(
                "error",
                "Error en el momento  crear el nuevo cliente.",
                7000
            );
        }
    };


    useEffect(() => {
        getAllCreditor();
        getProfessionals();
        getIPSUpdate();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <>
            <div>
                <div className="row">
                    <div className="col-lg-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-lg-4 col-sm-4">
                                        <h4 className="card-title fs-4">
                                            <i className="fa-solid fa-list"></i>&nbsp;Listado de acreedores
                                        </h4>

                                    </div>
                                    <div className="col-lg-4 col-sm-4">
                                        <input
                                            type="text"
                                            placeholder="Buscar acreedor por nombre."
                                            className="form-control mb-2"
                                            value={search}
                                            onChange={(e) => setSearch(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-lg-4 col-sm-4">
                                        <div className="d-flex justify-content-center justify-content-md-end py-2 p-md-0">
                                            <div className="position-relative d-inline-block">
                                            </div>
                                            <button
                                                className={
                                                    "badge fs-6 py-1 pe-2 text-success-emphasis bg-success-subtle border border-success-subtle rounded-pill"
                                                }
                                                type="button"
                                                onClick={() => handleShowCreate()}
                                                style={{ marginLeft: "10px" }}
                                            >
                                                <i className="fa-solid fa-plus"></i>&nbsp;Crear
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="row d-flex justify-center">
                                    <div className="col-lg-2 col-md-2">
                                        <p>
                                            Total de acreedores:&nbsp;
                                            <b className="fw-bold">{resumen.total_ips}</b>
                                        </p>
                                    </div>
                                </div>

                                <div className="table-responsive rounded-table" style={{
                                    maxHeight: "70vh",
                                    overflowY: "auto",
                                    zIndex: 1020
                                }}>

                                    <table className="table table-striped table-sm table-hover table-sm">
                                        <thead className="table-dark " style={{ position: "sticky", top: 0, zIndex: 10 }}>
                                            <tr>
                                                <th style={{ width: "5%", cursor: "pointer" }} >Municipio</th>
                                                <th style={{ width: "25%" }}>Nombre</th>
                                                <th style={{ width: "10%" }}>Tipo</th>
                                                <th style={{ width: "15%" }}>Documento</th>
                                                <th style={{ width: "15%" }}>Dirección</th>
                                                <th style={{ width: "18%" }}>Teléfono</th>
                                                <th style={{ width: "12%" }}>Correo</th>
                                                <th style={{ width: "12%" }}></th>
                                            </tr>
                                        </thead>
                                        <tbody className="table-group-divider ">
                                            {(sortedIps.length > 0 ? sortedIps : filteredIps).map((myCreditor, count) => (
                                                <tr key={count + 1}>
                                                    <td>{myCreditor.name_municipality}</td>
                                                    <td>{myCreditor.name_creditor}</td>
                                                    <td>{myCreditor.type_creditor}</td>
                                                    <td>{myCreditor.document_creditor}</td>
                                                    <td>{myCreditor.address_creditor}</td>
                                                    <td>{myCreditor.phone_creditor}</td>
                                                    <td>{myCreditor.email_creditor}</td>
                                                    <td>
                                                        <button
                                                            className={`badge fs-6 align-items-center p-1 pe-1 rounded-pill border ${myCreditor.is_active
                                                                ? "text-info-emphasis bg-info-subtle border-info-subtle"
                                                                : "text-secondary bg-secondary-subtle border-secondary"
                                                                }`}
                                                            onClick={() => getOneDataIps(myCreditor.id)}
                                                            disabled={!myCreditor.is_active}
                                                        >
                                                            <i className="fa-solid fa-info"></i>
                                                        </button>
                                                        &nbsp;
                                                        <button
                                                            className={`badge fs-6 align-items-center p-1 pe-1 rounded-pill border ${myCreditor.is_active
                                                                ? "text-dark-emphasis bg-dark-subtle border-dark-subtle"
                                                                : "text-secondary bg-secondary-subtle border-secondary"
                                                                }`}
                                                            onClick={() => getOneIpsUp(myCreditor.id)}
                                                            disabled={!myCreditor.is_active}
                                                        >
                                                            <i className="fa-solid fa-pen-to-square"></i>
                                                        </button>
                                                        &nbsp;
                                                        <button
                                                            className={`badge fs-6 align-items-center p-1 pe-1 rounded-pill border ${myCreditor.is_active
                                                                ? "text-primary-emphasis bg-primary-subtle border-primary-subtle"
                                                                : "text-secondary bg-secondary-subtle border-secondary"
                                                                }`}
                                                            onClick={() => getOneIpsUpDateA(myCreditor.id)}
                                                            disabled={!myCreditor.is_active}
                                                        >
                                                            <i className="fa-solid fa-a"></i>
                                                        </button>
                                                        &nbsp;
                                                        {arrayUsers?.role === "ADMINISTRADOR" ? (
                                                            <>
                                                                <button
                                                                    className={
                                                                        myCreditor.is_active
                                                                            ? "badge fs-6 py-1 pe-1 text-danger-emphasis bg-danger-subtle border border-danger-subtle rounded-pill"
                                                                            : "badge fs-6 py-1 pe-3 text-success-emphasis bg-success-subtle border border-success-subtle rounded-pill"
                                                                    }
                                                                    type="button"
                                                                    onClick={() => getOneIps(myCreditor.id)}

                                                                >
                                                                    {myCreditor.is_active ? (
                                                                        <>
                                                                            <i className="fa-regular fa-circle-xmark"></i>
                                                                            &nbsp;Inactivar
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <i className="fa-regular fa-circle-check"></i>
                                                                            &nbsp;Activar
                                                                        </>
                                                                    )}
                                                                </button>
                                                            </>
                                                        ) : ("")}

                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div className="d-flex align-items-center justify-content-center m-3"></div>
                                </div>


                                <Modal
                                    show={showData}
                                    onHide={handleCloseData}
                                    backdrop="static"
                                    keyboard={false}
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered
                                    size="xl"
                                >
                                    <Modal.Header closeButton>
                                        <Modal.Title className="text-center fw-bold">
                                            Datos de la ips
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <Card className="mt-0 border-0 shadow-none">
                                            {/* card body */}
                                            <Card.Body>
                                                {/* card title */}
                                                <Card.Title
                                                    as="h4"
                                                    className="d-flex justify-content-center fs-2"
                                                >
                                                    <i className="fa-solid fa-hospital-user"></i>
                                                    &nbsp;IPS
                                                </Card.Title>
                                                <span
                                                    className="text-uppercase fw-lighter  fs-6 ls-2"
                                                    style={{ color: "#0f0f70" }}
                                                >
                                                    <i className="fa-solid fa-clipboard-check"></i> Nombre de la ips:{" "}
                                                    <p className="fw-semibold text-black fs-5">
                                                        {objIps?.nombre_ips}
                                                    </p>
                                                </span>
                                                <Row>
                                                    <Col xs={8} className="mb-1">
                                                        <h6
                                                            className="text-uppercase fs-6 fw-lighter ls-2"
                                                            style={{ color: "#0f0f70" }}
                                                        >
                                                            <i className="fa-regular fa-id-card"></i> Código Ips
                                                        </h6>
                                                        <p className="fw-semibold fs-5 text-black">
                                                            {objIps?.cod_ips}
                                                        </p>
                                                    </Col>
                                                    <Col xs={4} className="mb-1">
                                                        <h6
                                                            className="text-uppercase fs-6 fw-lighter ls-2"
                                                            style={{ color: "#0f0f70" }}
                                                        >
                                                            <i className="fa-solid fa-calendar"></i> Contrato S/C
                                                        </h6>
                                                        <p className="fw-semibold fs-5 text-black">
                                                            {objIps?.date_contract
                                                                ? new Date(`${objIps.date_contract}T00:00:00`).toLocaleString(
                                                                    "es-CO",
                                                                    {
                                                                        year: "numeric",
                                                                        month: "2-digit",
                                                                        day: "2-digit",
                                                                    }
                                                                )
                                                                : "No Tiene contrato"}
                                                        </p>
                                                    </Col>
                                                    <Col xs={6}>
                                                        <h6
                                                            className="text-uppercase fw-lighter fs-6 ls-2"
                                                            style={{ color: "#0f0f70" }}
                                                        >
                                                            <i className="fa-regular fa-envelope"></i> Fecha de actualización y actualizado
                                                        </h6>
                                                        <p className="fw-semibold fs-5 text-black">
                                                            {objIps?.date_update2025
                                                                ? new Date(`${objIps.date_contract}T00:00:00`).toLocaleString(
                                                                    "es-CO",
                                                                    {
                                                                        year: "numeric",
                                                                        month: "2-digit",
                                                                        day: "2-digit",
                                                                    }
                                                                )
                                                                : "No Tiene actualización"}&nbsp;
                                                            {objIps?.date_updated
                                                                ? new Date(`${objIps.date_updated}T00:00:00`).toLocaleString(
                                                                    "es-CO",
                                                                    {
                                                                        year: "numeric",
                                                                        month: "2-digit",
                                                                        day: "2-digit",
                                                                    }
                                                                )
                                                                : "No Tiene actualizada"}
                                                        </p>
                                                    </Col>
                                                    <Col xs={6}>
                                                        <h6
                                                            className="text-uppercase fw-lighter fs-6 ls-2"
                                                            style={{ color: "#0f0f70" }}
                                                        >
                                                            <i className="fa-regular fa-envelope"></i> Conexión
                                                        </h6>
                                                        <p className="text-uppercase fw-semibold fs-5 text-black">
                                                            {objIps?.connection}
                                                        </p>
                                                    </Col>
                                                    <Col xs={6} className="mb-1">
                                                        <h6
                                                            className="text-uppercase fw-lighter fs-6 ls-2"
                                                            style={{ color: "#0f0f70" }}
                                                        >
                                                            <i className="fa-solid fa-phone-volume"></i> Contraseña de la conexión
                                                        </h6>
                                                        <p className="fw-semibold fs-5 text-black">
                                                            {objIps?.password_connection}
                                                        </p>
                                                    </Col>
                                                    <Col xs={6} className="mb-1">
                                                        <h6
                                                            className="text-uppercase fw-lighter fs-6 ls-2"
                                                            style={{ color: "#0f0f70" }}
                                                        >
                                                            <i className="fa-solid fa-phone-volume"></i> Nombre del servidor
                                                        </h6>
                                                        <p className="fw-semibold fs-5 text-black">
                                                            {objIps?.name_server}
                                                        </p>
                                                    </Col>
                                                    <Col xs={12}>
                                                        <h6
                                                            className="text-uppercase fw-lighter fs-6 ls-2"
                                                            style={{ color: "#0f0f70" }}
                                                        >
                                                            <i className="fa-regular fa-envelope"></i> Contraseña del servidor
                                                        </h6>
                                                        <p className="text-uppercase fw-semibold fs-5 text-black">
                                                            {objIps?.password_server}
                                                        </p>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button
                                            variant="danger"
                                            onClick={() => {
                                                setShowData(false);
                                            }}
                                        >
                                            <i className="fa-solid fa-backward"></i>
                                            &nbsp;Cerrar
                                        </Button>
                                    </Modal.Footer>
                                </Modal>


                                <Modal
                                    show={show2}
                                    onHide={handleClose2}
                                    backdrop="static"
                                    keyboard={false}
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered
                                    size="lg"
                                >
                                    <Modal.Header closeButton>
                                        <Modal.Title className="text-center fw-bold">
                                            <i className="fa-solid fa-folder-plus"></i>
                                            &nbsp;Formulario de creación
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Form
                                        className="forms-sample"
                                        validated={process}
                                        onSubmit={sendForm}
                                        noValidate
                                        ref={formRef}
                                    >
                                        <Modal.Body>
                                            <Form.Group controlId="name_creditor" className="mb-3 w-100">
                                                <Form.Label
                                                    className="fw-bold mb-2 mt-2"
                                                    htmlFor="name_creditor"
                                                >
                                                    Nombre acreedor:
                                                </Form.Label>
                                                <Form.Control
                                                    required
                                                    type="text"
                                                    name="name_creditor"
                                                    className="form-control"
                                                    id="name_creditor"
                                                    placeholder="Escriba el nombre del acreedor"
                                                    value={name_creditor}
                                                    onChange={(e) => {
                                                        let value = e.target.value.toUpperCase(); // Convierte a mayúsculas
                                                        // Validar que solo contenga letras y limitar a 60 caracteres
                                                        if (
                                                            /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]*$/.test(value) &&
                                                            value.length <= 60
                                                        ) {
                                                            e.target.value = value; // Establece el valor en mayúsculas
                                                            doubleLink(e); // Llama a tu función existente
                                                        }
                                                    }}
                                                    autoComplete="off"
                                                    maxLength={60} // Limita a 60 caracteres
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    Nombre del acreedor es obligatorio.
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <Form.Group controlId="type_creditor" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="type_creditor"
                                                        >
                                                            Tipo de acreedor:
                                                        </Form.Label>
                                                        <Form.Select
                                                            required
                                                            id="type_creditor"
                                                            name="type_creditor"
                                                            value={type_creditor}
                                                            onChange={(e) => {
                                                                doubleLink(e);

                                                            }}
                                                        >
                                                            <option value="">Seleccione el tipo de acreedor</option>
                                                            <option value="NI">NIT</option>
                                                            <option value="CC">Cédula de ciudadanía</option>
                                                            <option value="CE">Cédula de extranjería</option>
                                                            <option value="DE">Documento extranjero</option>
                                                            <option value="PA">Pasaporte</option>
                                                            <option value="OT">Otro</option>

                                                        </Form.Select>
                                                        <Form.Control.Feedback type="invalid">
                                                            El tipo de acreedor es obligatorio.
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-6">
                                                    <Form.Group controlId="document_creditor" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="document_creditor"
                                                        >
                                                            Documento del acreedor:
                                                        </Form.Label>
                                                        <Form.Control
                                                            required
                                                            type="text"
                                                            name="document_creditor"
                                                            className="form-control"
                                                            id="document_creditor"
                                                            placeholder="Escriba el documento del acreedor"
                                                            value={document_creditor}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                // Permitir solo números y limitar a 20 caracteres
                                                                if (/^\d*$/.test(value) && value.length <= 20) {
                                                                    doubleLink(e); // Llama a tu función existente
                                                                }
                                                            }}
                                                            autoComplete="off"
                                                            maxLength={17}
                                                        />
                                                        <Form.Control.Feedback type="invalid">
                                                            El documento del acreedor es obligatorio.
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-6">
                                                    <Form.Group controlId="address_creditor" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="address_creditor"
                                                        >
                                                            Dirrección del acreedor:
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="address_creditor"
                                                            className="form-control"
                                                            id="address_creditor"
                                                            placeholder="Escriba la dirección del acreedor"
                                                            value={address_creditor}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                // Permitir solo números y limitar a 20 caracteres
                                                                if (/^\d*$/.test(value) && value.length <= 20) {
                                                                    doubleLink(e); // Llama a tu función existente
                                                                }
                                                            }}
                                                            autoComplete="off"
                                                            maxLength={20} // Limita a 20 caracteres
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-6">
                                                    <Form.Group controlId="phone_creditor" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="phone_creditor"
                                                        >
                                                            Teléfono del acreedor:
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="phone_creditor"
                                                            className="form-control"
                                                            id="phone_creditor"
                                                            placeholder="Escriba el teléfono del acreedor"
                                                            value={phone_creditor}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                // Permitir solo números y limitar a 20 caracteres
                                                                if (/^\d*$/.test(value) && value.length <= 20) {
                                                                    doubleLink(e); // Llama a tu función existente
                                                                }
                                                            }}
                                                            autoComplete="off"
                                                            maxLength={20} // Limita a 20 caracteres
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-6">
                                                    <Form.Group controlId="email_creditor" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="email_creditor"
                                                        >
                                                            Correo del acreedor:
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="email_creditor"
                                                            className="form-control"
                                                            id="email_creditor"
                                                            placeholder="Escriba el correo del acreedor"
                                                            value={email_creditor}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                // Permitir solo números y limitar a 20 caracteres
                                                                if (/^\d*$/.test(value) && value.length <= 20) {
                                                                    doubleLink(e); // Llama a tu función existente
                                                                }
                                                            }}
                                                            autoComplete="off"
                                                            maxLength={20} // Limita a 20 caracteres
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-6">
                                                    <Form.Group
                                                        controlId="id_municipality"
                                                        className="mb-3 w-100"
                                                    >
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="id_municipality"
                                                        >
                                                            Municipio:
                                                        </Form.Label>
                                                        <Form.Select
                                                            required
                                                            id="id_municipality"
                                                            name="id_municipality"
                                                            value={id_municipality}
                                                            onChange={doubleLink}
                                                        >
                                                            <option value="">Selecciona un municipio</option>
                                                            {arrayMunicipio.map((municipio) => (
                                                                <option key={municipio.id} value={municipio.id}>
                                                                    {municipio.id} - {municipio?.id_deparment?.name_deparment}
                                                                </option>
                                                            ))}
                                                        </Form.Select>
                                                        <Form.Control.Feedback type="invalid">
                                                            EL municipio es obligatorio.
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </div>
                                            </div>












                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="danger" onClick={handleClose2}>
                                                <i className="fa-solid fa-backward"></i>&nbsp;Cancelar
                                            </Button>
                                            <Button
                                                variant="success"
                                                type="submit"
                                                onClick={() => { }}
                                            >
                                                <i className="fa-solid fa-plus"></i>&nbsp;Guardar
                                            </Button>
                                        </Modal.Footer>
                                    </Form>
                                </Modal>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </div>
        </>
    );
};
